var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"search_pop",attrs:{"id":_vm.components_id},on:{"mouseleave":_vm.leave,"mouseenter":_vm.enter}},[_c('div',{staticClass:"pop_target",attrs:{"id":_vm.target_id}},[_vm._t("target")],2),_c('div',{class:['pop_main', _vm.initPop && _vm.runClass],attrs:{"id":_vm.main_id}},[_vm._t("main")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }